<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size: 15px; font-weight: bold">new tarrif rate</small>
      </legend>
      <div>
        <form @submit.prevent="tarrifUpdate()">
          <div class="row">
            <div class="col-md-6">
              <input type="hidden" class="id" :value="Tarrif.id" />
              <div class="form-group">
                <label>Tarrif category</label>
                <select
                  name="tarrif_category"
                  class="form-control tarrif_category"
                  :value="Tarrif.tarrif_category"
                >
                  <option value>Select category</option>
                  <option value="ADMINISTRATIVE">ADMINISTRATIVE</option>
                  <option value="OPERATION">OPERATION</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Item name</label>
                <input
                  type="text"
                  class="form-control item_name"
                  :value="Tarrif.item_name"
                  placeholder="item name"
                  required
                />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat updatingTarrif">
            <i class="fa fa-ship"></i> update tarrif
          </button>
          <button type="button" class="btn btn-info btn-flat updatingTarrifLoader">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import $ from "jquery";
import router from "../router/index";
export default {
  created() {
    if (this.$store.getters.Tarrif.length === 0) {
      router.push("/managetarrifs");
    }
  },
  computed: {
    ...mapGetters(["Tarrif"])
  },
  methods: {
    ...mapActions(["tarrifUpdate"])
  }
};
</script>
<style scoped>
.updatingTarrifLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/tarrifs/updatetarrif.vue